import { FirebaseMessagingAPI } from '../PushAPI';
import { EVENTS } from '../../settings';
import { ready as swReady } from '../../sw';
import { getPayload } from '../../sync';
import { appStore } from '../../store';
import { getENV } from '../../env';
import { getConfigFCM } from '../../config';

import type { PushAPI, PushSubscriptionLike } from '../../types/push-api.types';
import type {
  Subscription,
  SubscriptionMethodParams,
} from '../../types/subscription.types';
import type { FirebaseMessagingAPIOptions } from '../../types/firebase-config.types';

/**
 * Класс для работы с PushAPI.
 * Может быть расширен для новых api.
 */
export class SubscriptionService implements Subscription {
  private readonly api: PushAPI = new FirebaseMessagingAPI();
  private readonly config: FirebaseMessagingAPIOptions = getConfigFCM(getENV());

  public getOrCreateSubscriptionApiFCM = (): Promise<PushSubscriptionLike> => {
    return this.api.subscribe(this.config);
  };

  public subscribe(params: SubscriptionMethodParams) {
    const { notify, emitter } = params;

    return swReady()
      .then(() => this.api.subscribe({ ...this.config, force: true }))
      .then((subscription) => {
        return notify(0, subscription)
          .catch((err: Error) => {
            emitter.emit(EVENTS.ERROR, err);
          })
          .then(() => subscription);
      })
      .then((subscription) => {
        return appStore.dispatch({
          type: EVENTS.SUBSCRIBE,
          subscription: getPayload(subscription),
        });
      })
      .then((state) => {
        emitter.emit(EVENTS.SUBSCRIBE, state.subscription);
      })
      .catch((err) => emitter.emit(EVENTS.ERROR, err));
  }

  public unsubscribe(params: SubscriptionMethodParams) {
    const { emitter, notify } = params;

    return swReady()
      .then(() => this.api.unsubscribe(this.config))
      .then((subscription) => {
        if (subscription) {
          return notify(-1, subscription).catch((err: Error) => {
            emitter.emit(EVENTS.ERROR, err);
          });
        }
      })
      .then(() => appStore.dispatch({ type: EVENTS.UNSUBSCRIBE }))
      .then(() => emitter.emit(EVENTS.UNSUBSCRIBE))
      .catch((err) => emitter.emit(EVENTS.ERROR, err));
  }

  public set applicationName(name: string) {
    this.api.appName = name;
  }
}
